import { defineComponent as _defineComponent } from 'vue'
import {getCurrentInstance, nextTick, onBeforeUnmount, onMounted, ref, watch} from 'vue';
import {ConfigStore} from "~/chat/ts/store/Config";
import Events from "~/ts/library/Events";


import {useSlots} from "vue";

const __default__ = {
    name: "ResizableTextarea",
    render() {
        return useSlots().default()[0];
    }
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {

let cloneTextarea = ref<HTMLTextAreaElement>();
let instance = getCurrentInstance().proxy;

onBeforeUnmount(() => {
    cloneTextarea.value.remove();
});

function setStyle() {
    initializeTextarea();
    let target = instance.$el as HTMLTextAreaElement;
    let computedStyles = window.getComputedStyle(instance.$el);

    let cssText = Array.from(computedStyles).reduce((str, property) => {
        return `${str}${property}:${computedStyles.getPropertyValue(property)} !important;`;
    }, '');

    cssText += `width: ${target.offsetWidth}px !important; position: absolute !important; height: 0 !important; min-height:0 !important; overflow: hidden !important; visibility: hidden !important; top: 0 !important; left: -100000px !important;`;
    cloneTextarea.value.style.cssText = cssText;
    cloneTextarea.value.value = target.value;
    target.style.setProperty("height", `${parseInt(cloneTextarea.value.scrollHeight as any) + 1}px`, 'important');
}

function initializeTextarea() {
    if (!cloneTextarea.value) {
        cloneTextarea.value = document.createElement("textarea");
        cloneTextarea.value.setAttribute("class", "cobrowse-ignore");
    }
    if (!cloneTextarea.value.parentElement) {
        instance.$el.parentElement.appendChild(cloneTextarea.value);
    }

}

onMounted(() => {
    nextTick(() => {
        setStyle();
    });
    setTimeout(() => setStyle(), 50);


    Events.addEventListener("input", instance.$el as HTMLElement, () => setStyle(), {passive: true});
});

let design = ConfigStore.design;

watch(design, () => setStyle(), {deep: true});

__expose({
    setStyle
});

/*
const render = () => {
    return instance.$slots.default[0];
};
 */

return { get cloneTextarea() { return cloneTextarea }, set cloneTextarea(v) { cloneTextarea = v }, get instance() { return instance }, set instance(v) { instance = v }, setStyle, initializeTextarea, get design() { return design }, set design(v) { design = v } }
}

})